import { JiraLogo } from '@atlaskit/logo';
import { ConfluenceBannerFirstPartyRecommendation } from '@post-office/components--confluence-banner-first-party-recommendation';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { createRender } from './types';
import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID } from '../../../common/constants';

export const render = createRender(({ onDismissed }) => {
	const intl = useIntl();
	return (
		<ConfluenceBannerFirstPartyRecommendation
			app={{
				hamsIdentifier: HAMS_PRODUCT_ID,
				ccpProductId: CCP_PRODUCT_ID,
				logo: (
					<JiraLogo
						appearance="brand"
						size="small"
						label={intl.formatMessage({
							id: 'post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text',
							description:
								'Alt text for the product logo in Jira recommendation message in Confluence Home Banner',
							defaultMessage: 'Jira Product Logo',
						})}
					/>
				),
				header: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header"
						description="Header for Jira recommendation message in Confluence Home Banner"
						defaultMessage="Visualize any project in a list, board, backlog, and more"
					/>
				),
				description: (
					<FormattedMessage
						id="post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description"
						description="Description for Jira recommendation message in Confluence Home Banner"
						defaultMessage="Jira lets you view your project and tasks in a way that works for you and your team."
					/>
				),
			}}
			onDismissed={onDismissed}
		/>
	);
});

export default render;
